<template>
  <div>
    <v-alert color="indigo" v-if="activeMessage" dark dismissible>
      {{ activeMessage }}
    </v-alert>

    <div class="text-center" v-if="hasActive()">
      <h1>Notificação atualmente ativa</h1>
      <v-card
        class="mx-auto"
        max-width="344"
        outlined
      >
        <v-card-title>
          {{ activeNotification.title }}
        </v-card-title>
        <v-card-text>
          {{ activeNotification.description }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="editActive"
            depressed
            color="primary"
          >
            Alterar
          </v-btn>
          <v-btn
            depressed
            color="error"
            @click="disabledActive"
          >
            Desativar
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>

    <v-divider class="my-16"></v-divider>

    <NotificationForm @notification="updateActive" :notification-id="editId"></NotificationForm>

    <v-divider class="my-10"></v-divider>

    <v-row justify="center">
      <v-col cols="8">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Sobre as notificações
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>Toda notificação possui um titulo e uma descrição. Caso não forneça um titulo, o frontend irá exibir como <strong>Rankdone informa</strong>.</p>
              <p>Essas notificações apenas são exibidas no front antigo. Sendo assim, apenas na tela de login e candidatos receberão esses avisos.</p>
              <p>Cada notificação é exibida uma unica vez via popup. Posteriormente, na tela de login e dashboard do candidato a mensagem permanecerá fixa.</p>
              <p>A mensagem permanece aparecendo para todos até ser desabilitada.</p>
              <p>Apenas uma mensagem pode ser exibida por vez. Então, ao criar uma nova notificação a anterior é desativada.</p>
              <p>Ao alterar uma notificação, ela não voltará a ser exibida via popup. Apenas refletirá nas partes fixas. Para exibir um novo popup, é necessário criar uma nova notificação.</p>
              <p><strong>Imagem 1 - </strong>Exemplo de popup aparecendo na tela de login.</p>
              <img src="@/assets/images/help/image1.png" alt="Tela de login com o popup" width="720px">
              <p><strong>Imagem 2 - </strong>Mensagem fixa na tela de login após fechar popup.</p>
              <img src="@/assets/images/help/image2.png" alt="Tela de login com mensagem fixa" width="720px">
              <p><strong>Imagem 3 - </strong>Mensagem fixa na dashboard do candidato após fechar popup.</p>
              <img src="@/assets/images/help/image3.png" alt="Dashboard do candidato com mensagem fixa" width="720px">
              <p><strong>Imagem 4 - </strong>Exemplo de popup aparecendo durante execução do teste em dispositivo móvel.</p>
              <img src="@/assets/images/help/image4.png" alt="Execução do teste com o popup em dispositivo móvel" width="720px">
              <p><strong>Imagem 5 - </strong>Mensagem fixa na dashboard do candidato em dispositivo móvel.</p>
              <img src="@/assets/images/help/image5.png" alt="Dashboard do candidato com mensagem fixa em dispositivo móvel" width="720px">
              <p><strong>Imagem 6 - </strong>Mensagem fixa na tela de login em dispositivo móvel.</p>
              <img src="@/assets/images/help/image6.png" alt="Tela de login com mensagem fixa em dispositivo móvel" width="720px">
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import NotificationService from '../../../../services/notification/notification.service';
import NotificationForm from './NotificationForm';

const notificationService = new NotificationService();

export default {
  name: 'Notifications',
  data: () => ({
    activeNotification: {},
    activeMessage: null,
    notifications: [],
    editId: null,
    snackbar: false,
    snackbarText: null,
  }),
  mounted() {
    this.updateActive();
    this.updateList();
  },
  components: {
    NotificationForm,
  },
  methods: {
    hasActive() {
      return Object.keys(this.activeNotification).length;
    },
    updateActive() {
      this.editId = null;

      notificationService
        .getActive()
        .then((response) => {
          this.activeNotification = response.data;
          this.activeMessage = null;

          if (!this.hasActive()) {
            this.activeMessage = 'Não há nenhuma notificação ativa no momento!';
          }
        })
        .catch(() => {
          this.activeNotification = {};
          this.activeMessage = 'Falha ao tentar buscar pela notificação ativa.';
        });
    },
    updateList() {
      notificationService
        .list()
        .then((response) => {
          this.notifications = response.data;
        })
        .catch(() => {
          this.notifications = [];
        });
    },
    editActive() {
      this.editId = this.activeNotification.id;
    },
    disabledActive() {
      notificationService
        .disabledActive()
        .then((response) => {
          this.updateActive();
          this.snackbar = true;
          this.snackbarText = response.data.message;
        })
        .catch((err) => {
          this.updateActive();
          this.snackbar = true;
          this.snackbarText = err?.response?.data?.message ?? 'Failed to disable notification';
        });
    },
  },
};
</script>

<style scoped>

</style>
